import { render, staticRenderFns } from "./choiceaplet.vue?vue&type=template&id=63a88366&scoped=true"
import script from "./choiceaplet.vue?vue&type=script&lang=js"
export * from "./choiceaplet.vue?vue&type=script&lang=js"
import style0 from "./choiceaplet.vue?vue&type=style&index=0&id=63a88366&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a88366",
  null
  
)

export default component.exports